import PageHeading from "../../../components/desktop/PageHeading";
import React, { useState, useEffect, useRef } from "react";
import { useAuthStore } from "../../../store/authStore";
import { toast } from "react-toastify";
import { api } from "../../../utils/api";

import { FaRegEdit } from "react-icons/fa";
import { FiCalendar } from "react-icons/fi";
import "./Userlistmaster.css";
import back from "../../../assets/back.png";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useLoaderStore } from "../../../store/loaderStore";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import ExcelJS from "exceljs";
import * as XLSX from "xlsx";

export default function Userlistmaster() {
  const { showLoader, hideLoader } = useLoaderStore();
  const [activeTab, setActiveTab] = useState("personal");

  const [shifts, setShifts] = useState([]);
  const [shiftLoading, setShiftLoading] = useState(false);
  const [userShiftAssignments, setUserShiftAssignments] = useState([]);
  const [showShiftForm, setShowShiftForm] = useState(false);

  const [userWeekoffAssignments, setUserWeekoffAssignments] = useState([]);
  const [weekoffLoading, setWeekoffLoading] = useState(false);
  const [weekoffFilter, setWeekoffFilter] = useState({
    from_date: "",
    to_date: "",
  });

  const shiftFromDateRef = useRef(null);
  const shiftToDateRef = useRef(null);

  const shiftRowFromDateRefs = useRef({});
  const shiftRowToDateRefs = useRef({});
  const shiftAssignmentFromDateRefs = useRef({});
  const shiftAssignmentToDateRefs = useRef({});

  const weekoffRowFromDateRefs = useRef({});
  const weekoffRowToDateRefs = useRef({});
  const weekoffFromDateRef = useRef(null);
  const weekoffToDateRef = useRef(null);
  const weekoffAssignmentFromDateRefs = useRef({});
  const weekoffAssignmentToDateRefs = useRef({});

  const { user, isAuthenticated } = useAuthStore();
  const companyId = user?.company_id;

  const [users, setUsers] = useState([]);
  const [locations, setLocations] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const importInputRef = useRef(null);
  const [importPreview, setImportPreview] = useState(null);
  const [isImportSubmitting, setIsImportSubmitting] = useState(false);
  const [importProgress, setImportProgress] = useState({ current: 0, total: 0 });
  const [showDownloadChoice, setShowDownloadChoice] = useState(false);
  const [isTemplateDownloading, setIsTemplateDownloading] = useState(false);
  const [isImportPreparing, setIsImportPreparing] = useState(false);

  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [devices, setDevices] = useState([]);
  const [deviceSearch, setDeviceSearch] = useState("");
  const deviceDropdownRef = useRef(null);
  const [showDeviceDropdown, setShowDeviceDropdown] = useState(false);
  const [shiftForm, setShiftForm] = useState({
    shift: "",
    from_date: "",
    to_date: "",
  });

  const [shiftFilter, setShiftFilter] = useState({
    from_date: "",
    to_date: "",
  });

  const weekDays = [
    { label: "S", value: 0 },
    { label: "M", value: 1 },
    { label: "T", value: 2 },
    { label: "W", value: 3 },
    { label: "T", value: 4 },
    { label: "F", value: 5 },
    { label: "S", value: 6 },
  ];

  const fetchLocations = async () => {
    try {
      showLoader("master");
      const response = await api.get(`/location/active-list/${companyId}`);

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to load locations");
      }

      setLocations(result);
      return result;
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Failed to load locations");
    } finally {
      hideLoader();
    }
  };

  const fetchDepartments = async () => {
    try {
      showLoader("master");
      const response = await api.get(`/department/active-list/${companyId}`);

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to load departments");
      }

      setDepartments(result);
      return result;
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Failed to load departments");
    } finally {
      hideLoader();
    }
  };

  const fetchDesignations = async () => {
    try {
      showLoader("master");
      const response = await api.get(`/designation/active-list/${companyId}`);

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to load designations");
      }

      setDesignations(result);
      return result;
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Failed to load designations");
    } finally {
      hideLoader();
    }
  };

  const fetchDevices = async () => {
    try {
      const response = await api.get(`/device/list/${companyId}`);

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to load devices");
      }

      console.log("DEVICE LIST API RESPONSE:", result);

      // API returns direct array
      const deviceList = Array.isArray(result)
        ? result
        : Array.isArray(result?.data)
          ? result.data
          : [];

      const activeDevices = deviceList.filter(
        (device) =>
          Number(device.isactive) === 1 && Number(device.isdelete || 0) === 0,
      );

      console.log("ACTIVE DEVICES:", activeDevices);

      setDevices(activeDevices);

      return activeDevices;
    } catch (error) {
      console.error("FETCH DEVICES ERROR:", error);
      toast.error(error.message || "Failed to load devices");
      setDevices([]);
      return [];
    }
  };

  const fetchUsers = async (showToast = false) => {
    try {
      showLoader("master");

      const response = await api.get(`/user/list/${companyId}`);

      const result = await response.json();

      setUsers(result);

      if (showToast) {
        toast.success("Users fetched successfully");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Failed to load users");
    } finally {
      hideLoader();
    }
  };

  const fetchShifts = async () => {
    try {
      setShiftLoading(true);

      const response = await api.get(`/shift/active-list/${companyId}`);

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to load shifts");
      }

      setShifts(result);
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Failed to load shifts");
    } finally {
      setShiftLoading(false);
    }
  };

  const fetchUserShiftAssignments = async (
    userId,
    fromDate = shiftFilter.from_date,
    toDate = shiftFilter.to_date,
  ) => {
    try {
      if (!companyId || !userId) return;

      // If dates are not selected, use current month
      if (!fromDate || !toDate) {
        const today = new Date();

        const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

        const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");

          return `${year}-${month}-${day}`;
        };

        fromDate = formatDate(firstDay);
        toDate = formatDate(lastDay);
      }

      if (new Date(fromDate) > new Date(toDate)) {
        toast.warning("From Date cannot be after To Date");
        return;
      }

      setShiftLoading(true);

      console.log("FETCH SHIFT ASSIGNMENTS:", {
        userId,
        fromDate,
        toDate,
      });

      const response = await api.get(
        `/shift-assignment/user/${companyId}/${userId}?from_date=${fromDate}&to_date=${toDate}`,
      );

      const result = await response.json();

      console.log("USER SHIFT ASSIGNMENTS:", result);

      if (result.status) {
        setUserShiftAssignments(result.data || []);
      } else {
        setUserShiftAssignments([]);
      }
    } catch (error) {
      console.error("FETCH USER SHIFT ASSIGNMENTS ERROR:", error);

      setUserShiftAssignments([]);

      toast.error(error.message || "Failed to load shift assignments");
    } finally {
      setShiftLoading(false);
    }
  };

  const fetchUserWeekoffAssignments = async (
    userId,
    fromDate = weekoffFilter.from_date,
    toDate = weekoffFilter.to_date,
  ) => {
    try {
      if (!companyId || !userId) return;

      // If dates are not selected, use current month
      if (!fromDate || !toDate) {
        const today = new Date();

        const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

        const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");

          return `${year}-${month}-${day}`;
        };

        fromDate = formatDate(firstDay);
        toDate = formatDate(lastDay);
      }

      if (new Date(fromDate) > new Date(toDate)) {
        toast.warning("From Date cannot be after To Date");
        return;
      }

      setWeekoffLoading(true);

      console.log("FETCH WEEKOFF ASSIGNMENTS:", {
        userId,
        fromDate,
        toDate,
      });

      const response = await api.get(
        `/weekoff-assignment/user/${companyId}/${userId}?from_date=${fromDate}&to_date=${toDate}`,
      );

      const result = await response.json();

      console.log("USER WEEKOFF ASSIGNMENTS:", result);

      if (result.status) {
        setUserWeekoffAssignments(result.data || []);
      } else {
        setUserWeekoffAssignments([]);
      }
    } catch (error) {
      console.error("FETCH USER WEEKOFF ASSIGNMENTS ERROR:", error);

      setUserWeekoffAssignments([]);

      toast.error(error.message || "Failed to load weekoff assignments");
    } finally {
      setWeekoffLoading(false);
    }
  };

  const handleShiftFilter = async () => {
    if (!editId) {
      return;
    }

    if (!shiftFilter.from_date) {
      toast.warning("Please select From Date");
      return;
    }

    if (!shiftFilter.to_date) {
      toast.warning("Please select To Date");
      return;
    }

    if (new Date(shiftFilter.from_date) > new Date(shiftFilter.to_date)) {
      toast.warning("From Date cannot be after To Date");
      return;
    }

    await fetchUserShiftAssignments(
      editId,
      shiftFilter.from_date,
      shiftFilter.to_date,
    );
  };

  const handleWeekoffFilter = async () => {
    if (!editId) {
      return;
    }

    if (!weekoffFilter.from_date) {
      toast.warning("Please select From Date");
      return;
    }

    if (!weekoffFilter.to_date) {
      toast.warning("Please select To Date");
      return;
    }

    if (new Date(weekoffFilter.from_date) > new Date(weekoffFilter.to_date)) {
      toast.warning("From Date cannot be after To Date");
      return;
    }

    await fetchUserWeekoffAssignments(
      editId,
      weekoffFilter.from_date,
      weekoffFilter.to_date,
    );
  };

  const handleResetShiftFilter = async () => {
    const today = new Date();

    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    };

    const fromDate = formatDate(firstDay);
    const toDate = formatDate(lastDay);

    setShiftFilter({
      from_date: fromDate,
      to_date: toDate,
    });

    if (editId) {
      await fetchUserShiftAssignments(editId, fromDate, toDate);
    }
  };

  const handleResetWeekoffFilter = async () => {
    const today = new Date();

    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    };

    const fromDate = formatDate(firstDay);
    const toDate = formatDate(lastDay);

    setWeekoffFilter({
      from_date: fromDate,
      to_date: toDate,
    });

    if (editId) {
      await fetchUserWeekoffAssignments(editId, fromDate, toDate);
    }
  };

  useEffect(() => {
    if (companyId && isAuthenticated) {
      fetchUsers(true);
    }
  }, [companyId, isAuthenticated]);

  const loadDropdowns = async () => {
    return Promise.all([
      fetchLocations(),
      fetchDepartments(),
      fetchDesignations(),
      fetchDevices(),
    ]);
  };

  // Import/template dropdowns do not contain devices, so avoid the active
  // device API request for those actions.
  const loadImportDropdowns = async () =>
    Promise.all([fetchLocations(), fetchDepartments(), fetchDesignations()]);

  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);

  const [form, setForm] = useState({
    employee_code: "",
    first_name: "",
    last_name: "",
    gender: "",
    email_id: "",
    country_code: "+91",
    mobile_no: "",
    password: "",
    role: "",
    desktop_access: "",
    mobile_punchin_access: "",
    department: "",
    designation: "",
    location: "",
    reporting_manager: "",
    devices: [],
    status: true,
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        deviceDropdownRef.current &&
        !deviceDropdownRef.current.contains(event.target)
      ) {
        setShowDeviceDropdown(false);
        setDeviceSearch("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleStatus = async (item) => {
    try {
      showLoader("master");

      // Get complete user data first
      const userResponse = await api.get(`/user/${item.id}/${companyId}`);

      const userData = await userResponse.json();

      if (!userResponse.ok) {
        throw new Error(userData.message || "Failed to load user");
      }

      const response = await api.put(`/user/update/${item.id}`, {
        company_id: userData.company_id,
        employee_code: userData.employee_code,
        first_name: userData.first_name,
        last_name: userData.last_name,
        email_id: userData.email_id,
        country_code: userData.country_code,
        mobile_no: userData.mobile_no,

        // Required by backend
        password: userData.password,

        role: Number(userData.role),
        desktop_access: Number(userData.desktop_access),
        is_allow_mobilepunch: Number(userData.is_allow_mobilepunch ?? 0),
        department: Number(userData.department),
        designation: Number(userData.designation),
        location: Number(userData.location),
        reporting_manager: Number(userData.reporting_manager),
        gender: userData.gender,

        device_allowed: Array.isArray(userData.device_allowed)
          ? userData.device_allowed.map((device) =>
              Number(typeof device === "object" ? device.id : device),
            )
          : [],

        isactive: userData.isactive === 1 ? 0 : 1,
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Status update failed");
      }

      await fetchUsers();

      toast.success(
        `User ${
          item.isactive === 1 ? "deactivated" : "activated"
        } successfully`,
      );
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Status update failed");
    } finally {
      hideLoader();
    }
  };

  const handleEdit = async (item) => {
    try {
      showLoader("master");

      // Load dropdown options first
      await loadDropdowns();

      // Fetch selected user
      const response = await api.get(`/user/${item.id}/${companyId}`);

      const data = await response.json();
      await fetchShifts();
      await fetchUserShiftAssignments(item.id);

      if (!response.ok) {
        throw new Error(data.message || "Failed to load user");
      }

      console.log("EDIT USER API RESPONSE:", data);

      const allowedDeviceIds = (() => {
        if (Array.isArray(data.device_allowed)) {
          return data.device_allowed
            .map((device) =>
              Number(typeof device === "object" ? device.id : device),
            )
            .filter((id) => !isNaN(id));
        }

        if (
          data.device_allowed !== null &&
          data.device_allowed !== undefined &&
          data.device_allowed !== ""
        ) {
          return String(data.device_allowed)
            .split(",")
            .map((id) => Number(id.trim()))
            .filter((id) => !isNaN(id));
        }

        return [];
      })();

      const allowedDevices = devices.filter((device) =>
        allowedDeviceIds.includes(Number(device.id)),
      );

      console.log("ALLOWED DEVICES:", allowedDevices);

      allowedDevices.forEach((device) => {
        console.log("Device ID:", device.id);
        console.log("Device Code:", device.device_code);
        console.log("Device Name:", device.device_name);
      });

      setEditId(item.id);
      setActiveTab("personal");

      setForm({
        employee_code: data.employee_code || "",
        first_name: data.first_name || "",
        last_name: data.last_name || "",
        gender: data.gender || "",
        email_id: data.email_id || "",

        // Mobile
        country_code: data.country_code
          ? String(data.country_code).startsWith("+")
            ? String(data.country_code)
            : `+${data.country_code}`
          : "+91",

        mobile_no: data.mobile_no
          ? String(data.mobile_no).replace(/\D/g, "")
          : "",

        password: data.password || "",

        role: String(data.role ?? ""),

        desktop_access:
          data.desktop_access !== null && data.desktop_access !== undefined
            ? Number(data.desktop_access)
            : "",
        mobile_punchin_access: String(Number(data.is_allow_mobilepunch ?? 0)),

        // Dropdowns
        department:
          data.department !== null && data.department !== undefined
            ? String(data.department)
            : "",

        designation:
          data.designation !== null && data.designation !== undefined
            ? String(data.designation)
            : "",

        location:
          data.location !== null && data.location !== undefined
            ? String(data.location)
            : "",

        reporting_manager:
          data.reporting_manager !== null &&
          data.reporting_manager !== undefined
            ? String(data.reporting_manager)
            : "",

        devices: (() => {
          if (Array.isArray(data.device_allowed)) {
            return data.device_allowed
              .map((device) =>
                Number(typeof device === "object" ? device.id : device),
              )
              .filter((id) => !isNaN(id));
          }

          if (
            data.device_allowed !== null &&
            data.device_allowed !== undefined &&
            data.device_allowed !== ""
          ) {
            return String(data.device_allowed)
              .split(",")
              .map((id) => Number(id.trim()))
              .filter((id) => !isNaN(id));
          }

          return [];
        })(),

        status: Number(data.isactive) === 1,
      });

      setShowForm(true);
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Failed to load user");
    } finally {
      hideLoader();
    }
  };

  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

  const handleSave = async () => {
    if (!form.first_name.trim()) {
      toast.warning("First Name is required");
      return;
    }

    if (!form.last_name.trim()) {
      toast.warning("Last Name is required");
      return;
    }

    if (!form.email_id.trim()) {
      toast.warning("Email is required");
      return;
    }

    if (!emailRegex.test(form.email_id.trim())) {
      toast.warning("Please enter a valid email address");
      return;
    }

    if (!editId && !form.password.trim()) {
      toast.warning("Password is required");
      return;
    }

    if (!form.role) {
      toast.warning("Please select role");
      return;
    }

    if (form.desktop_access === "" || form.desktop_access === null) {
      toast.warning("Please select Desktop Access");
      return;
    }

    if (!["0", "1"].includes(String(form.mobile_punchin_access))) {
      toast.warning("Please select Mobile Punchin access");
      return;
    }

    if (!form.department) {
      toast.warning("Please select department");
      return;
    }

    if (!form.designation) {
      toast.warning("Please select designation");
      return;
    }

    if (!form.location) {
      toast.warning("Please select location");
      return;
    }

    if (!form.gender) {
      toast.warning("Please select Gender");
      return;
    }

    if (!form.reporting_manager) {
      toast.warning("Please select Reporting Manager");
      return;
    }

    try {
      let response;

      if (editId) {
        

        response = await api.put(`/user/update/${editId}`, {
          company_id: companyId,
          employee_code: form.employee_code,
          first_name: form.first_name,
          last_name: form.last_name,
          email_id: form.email_id,
          country_code: form.country_code,
          mobile_no: form.mobile_no,
          password: form.password,
          role: Number(form.role),
          desktop_access: Number(form.desktop_access),
          is_allow_mobilepunch: Number(form.mobile_punchin_access),
          department: Number(form.department),
          designation: Number(form.designation),
          location: Number(form.location),
          reporting_manager: Number(form.reporting_manager),
          gender: form.gender,
          device_allowed: form.devices.map(Number),
          isactive: form.status ? 1 : 0,
        });
      } else {
        response = await api.post(`/user/add`, {
          company_id: companyId,
          employee_code: form.employee_code,
          first_name: form.first_name,
          last_name: form.last_name,
          email_id: form.email_id,
          country_code: form.country_code,
          mobile_no: form.mobile_no,
          password: form.password,
          role: Number(form.role),
          desktop_access: Number(form.desktop_access),
          is_allow_mobilepunch: Number(form.mobile_punchin_access),
          department: Number(form.department),
          designation: Number(form.designation),
          location: Number(form.location),
          reporting_manager: Number(form.reporting_manager),
          gender: form.gender,
          device_allowed: form.devices.map(Number),
        });
      }

      const result = await response.json();

      if (!response.ok) {
        let errorMessage = "Save failed";

        if (typeof result?.message === "string") {
          errorMessage = result.message;
        } else if (typeof result?.error === "string") {
          errorMessage = result.error;
        } else if (typeof result?.detail === "string") {
          errorMessage = result.detail;
        } else if (Array.isArray(result?.detail)) {
          errorMessage = result.detail
            .map((err) => {
              if (typeof err === "string") {
                return err;
              }

              return err?.msg || "Invalid input";
            })
            .join(", ");
        } else if (Array.isArray(result?.errors)) {
          errorMessage = result.errors
            .map((err) => {
              if (typeof err === "string") {
                return err;
              }

              return err?.msg || "Invalid input";
            })
            .join(", ");
        }

        throw new Error(errorMessage);
      }

      await fetchUsers();

      toast.success(
        editId ? "User updated successfully" : "User added successfully",
      );
      handleCancel();
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Save failed");
    }
  };

  const handleCancel = () => {
    setForm({
      employee_code: "",
      first_name: "",
      last_name: "",
      gender: "",
      email_id: "",
      country_code: "+91",
      mobile_no: "",
      password: "",
      role: "",
      desktop_access: "",
      mobile_punchin_access: "",
      department: "",
      designation: "",
      location: "",
      reporting_manager: "",
      devices: [],
      status: true,
    });

    setDeviceSearch("");
    setShowDeviceDropdown(false);

    setEditId(null);
    setShowForm(false);
  };

  const validateDateYear = (date, fieldName) => {
    if (!date) {
      toast.warning(`Please select ${fieldName}`);
      return false;
    }

    const year = date.split("-")[0];

    if (!/^\d{4}$/.test(year)) {
      toast.warning(`${fieldName} must have a 4-digit year`);
      return false;
    }

    return true;
  };

  const handleShiftSave = async () => {
    if (!shiftForm.shift) {
      toast.warning("Please select shift");
      return;
    }

    if (!validateDateYear(shiftForm.from_date, "From Date")) {
      return;
    }

    if (!validateDateYear(shiftForm.to_date, "To Date")) {
      return;
    }

    if (new Date(shiftForm.from_date) > new Date(shiftForm.to_date)) {
      toast.warning("From Date cannot be after To Date");
      return;
    }

    try {
      showLoader("master");

      const response = await api.post(`/shift-assignment/add`, {
        company_id: companyId,
        user_id: editId,
        shift_id: Number(shiftForm.shift),
        from_date: shiftForm.from_date,
        to_date: shiftForm.to_date,
      });

      const result = await response.json();

      if (
        !response.ok ||
        result.status === false ||
        result.status === "false" ||
        result.status === 0
      ) {
        throw new Error(result.message || "Shift assignment failed");
      }

      toast.success("Shift assigned successfully");

      setShiftForm({
        shift: "",
        from_date: "",
        to_date: "",
      });
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Shift assignment failed");
    } finally {
      hideLoader();
    }
  };

  const handleShiftRowSave = async (assignment) => {
    // Validation
    if (!assignment.shift_id) {
      toast.warning("Please select shift");
      return;
    }

    if (!validateDateYear(assignment.from_date, "From Date")) {
      return;
    }

    if (!validateDateYear(assignment.to_date, "To Date")) {
      return;
    }

    if (new Date(assignment.from_date) > new Date(assignment.to_date)) {
      toast.warning("From Date cannot be after To Date");
      return;
    }

    try {
      showLoader("master");

      const payload = {
        company_id: Number(companyId),
        user_id: Number(editId),
        shift_id: Number(assignment.shift_id),
        from_date: assignment.from_date,
        to_date: assignment.to_date,
        isactive: Number(assignment.isactive) === 1,
      };

      let response;

      // NEW ROW -> POST
      if (!assignment.assignment_id) {
        console.log("SHIFT ASSIGNMENT ADD PAYLOAD:", payload);

        response = await api.post(`/shift-assignment/add`, payload);
      }

      // EXISTING ROW -> PUT
      else {
        console.log("SHIFT ASSIGNMENT UPDATE PAYLOAD:", payload);

        response = await api.put(
          `/shift-assignment/update/${assignment.assignment_id}`,
          payload,
        );
      }

      const result = await response.json();

      if (result.status) {
        toast.success(
          assignment.assignment_id
            ? "Shift assignment updated successfully"
            : "Shift assignment added successfully",
        );

        // Reload assignments
        await fetchUserShiftAssignments(editId);
      } else {
        toast.error(result.message || "Failed to save shift assignment");
      }
    } catch (error) {
      console.error("SHIFT ASSIGNMENT SAVE ERROR:", error);

      toast.error(error.message || "Failed to save shift assignment");
    } finally {
      hideLoader();
    }
  };

  const handleShiftStatusToggle = async (assignment, checked) => {
    // New assignment has no ID yet
    if (!assignment.assignment_id) {
      setUserShiftAssignments((prev) =>
        prev.map((item) =>
          item === assignment
            ? {
                ...item,
                isactive: checked ? 1 : 0,
              }
            : item,
        ),
      );

      return;
    }

    try {
      showLoader("master");

      const payload = {
        company_id: Number(companyId),
        user_id: Number(editId),
        shift_id: Number(assignment.shift_id),
        from_date: assignment.from_date,
        to_date: assignment.to_date,
        isactive: checked,
      };

      console.log("SHIFT STATUS UPDATE PAYLOAD:", payload);

      const response = await api.put(
        `/shift-assignment/update/${assignment.assignment_id}`,
        payload,
      );

      const result = await response.json();

      if (!response.ok || !result.status) {
        throw new Error(result.message || "Failed to update shift status");
      }

      // Update UI immediately
      setUserShiftAssignments((prev) =>
        prev.map((item) =>
          item.assignment_id === assignment.assignment_id
            ? {
                ...item,
                isactive: checked ? 1 : 0,
              }
            : item,
        ),
      );

      toast.success(
        checked
          ? "Shift assignment activated successfully"
          : "Shift assignment deactivated successfully",
      );
    } catch (error) {
      console.error("SHIFT STATUS UPDATE ERROR:", error);

      // Keep the toggle unchanged if API fails
      setUserShiftAssignments((prev) =>
        prev.map((item) =>
          item.assignment_id === assignment.assignment_id
            ? {
                ...item,
                isactive: checked ? 0 : 1,
              }
            : item,
        ),
      );

      toast.error(error.message || "Failed to update shift status");
    } finally {
      hideLoader();
    }
  };

  // ==========================================
  // WEEKOFF ASSIGNMENT HANDLERS
  // ==========================================

  const handleWeekoffRowSave = async (assignment) => {
    // Validation
    if (!validateDateYear(assignment.from_date, "From Date")) {
      return;
    }

    if (!validateDateYear(assignment.to_date, "To Date")) {
      return;
    }

    if (new Date(assignment.from_date) > new Date(assignment.to_date)) {
      toast.warning("From Date cannot be after To Date");
      return;
    }

    // Validate weekoff_days
    let weekoffDaysArray = [];
    if (
      typeof assignment.weekoff_days === "string" &&
      assignment.weekoff_days
    ) {
      weekoffDaysArray = assignment.weekoff_days
        .split(",")
        .map((d) => parseInt(d.trim(), 10));
    } else if (Array.isArray(assignment.weekoff_days)) {
      weekoffDaysArray = assignment.weekoff_days;
    }

    if (!weekoffDaysArray || weekoffDaysArray.length === 0) {
      toast.warning("Please select at least one weekoff day");
      return;
    }

    try {
      showLoader("master");

      const payload = {
        company_id: Number(companyId),
        user_id: Number(editId),
        from_date: assignment.from_date,
        to_date: assignment.to_date,
        weekoff_days: weekoffDaysArray,
        isactive: Number(assignment.isactive) === 1,
      };

      let response;

      // NEW ROW -> POST
      if (!assignment.assignment_id) {
        console.log("WEEKOFF ASSIGNMENT ADD PAYLOAD:", payload);

        response = await api.post(`/weekoff-assignment/add`, payload);
      }

      // EXISTING ROW -> PUT
      else {
        console.log("WEEKOFF ASSIGNMENT UPDATE PAYLOAD:", payload);

        response = await api.put(
          `/weekoff-assignment/update/${assignment.assignment_id}`,
          payload,
        );
      }

      const result = await response.json();

      if (result.status) {
        toast.success(
          assignment.assignment_id
            ? "Weekoff assignment updated successfully"
            : "Weekoff assignment added successfully",
        );

        // Reload assignments
        await fetchUserWeekoffAssignments(editId);
      } else {
        toast.error(result.message || "Failed to save weekoff assignment");
      }
    } catch (error) {
      console.error("WEEKOFF ASSIGNMENT SAVE ERROR:", error);

      toast.error(error.message || "Failed to save weekoff assignment");
    } finally {
      hideLoader();
    }
  };

  const handleDeviceDropdownToggle = () => {
    if (!showDeviceDropdown) {
      setShowDeviceDropdown(true);
      setDeviceSearch("");
      setTimeout(() => {
        const dropdownElement =
          deviceDropdownRef.current?.querySelector(".device-dropdown");
        if (dropdownElement) {
          const rect = dropdownElement.getBoundingClientRect();
          if (rect.bottom > window.innerHeight - 50) {
            dropdownElement.classList.add("show-above");
          } else {
            dropdownElement.classList.remove("show-above");
          }
        }
      }, 0);
    } else {
      setShowDeviceDropdown(false);
    }
  };

  const handleWeekoffStatusToggle = async (assignment, checked) => {
    // New assignment has no ID yet
    if (!assignment.assignment_id) {
      setUserWeekoffAssignments((prev) =>
        prev.map((item) =>
          item === assignment
            ? {
                ...item,
                isactive: checked ? 1 : 0,
              }
            : item,
        ),
      );

      return;
    }

    try {
      showLoader("master");

      // Parse weekoff_days to array format
      let weekoffDaysArray = [];
      if (
        typeof assignment.weekoff_days === "string" &&
        assignment.weekoff_days
      ) {
        weekoffDaysArray = assignment.weekoff_days
          .split(",")
          .map((d) => parseInt(d.trim(), 10));
      } else if (Array.isArray(assignment.weekoff_days)) {
        weekoffDaysArray = assignment.weekoff_days;
      }

      const payload = {
        company_id: Number(companyId),
        user_id: Number(editId),
        from_date: assignment.from_date,
        to_date: assignment.to_date,
        weekoff_days: weekoffDaysArray,
        isactive: checked,
      };

      console.log("WEEKOFF STATUS UPDATE PAYLOAD:", payload);

      const response = await api.put(
        `/weekoff-assignment/update/${assignment.assignment_id}`,
        payload,
      );

      const result = await response.json();

      if (!response.ok || !result.status) {
        throw new Error(result.message || "Failed to update weekoff status");
      }

      // Update UI immediately
      setUserWeekoffAssignments((prev) =>
        prev.map((item) =>
          item.assignment_id === assignment.assignment_id
            ? {
                ...item,
                isactive: checked ? 1 : 0,
              }
            : item,
        ),
      );

      toast.success(
        checked
          ? "Weekoff assignment activated successfully"
          : "Weekoff assignment deactivated successfully",
      );
    } catch (error) {
      console.error("WEEKOFF STATUS UPDATE ERROR:", error);

      // Keep the toggle unchanged if API fails
      setUserWeekoffAssignments((prev) =>
        prev.map((item) =>
          item.assignment_id === assignment.assignment_id
            ? {
                ...item,
                isactive: checked ? 0 : 1,
              }
            : item,
        ),
      );

      toast.error(error.message || "Failed to update weekoff status");
    } finally {
      hideLoader();
    }
  };

  const handleSaveAllAssignments = async () => {
    if (activeTab === "shift") {
      // Loop through all shift assignments and save each one
      for (const assignment of userShiftAssignments) {
        if (assignment.shift_id && assignment.from_date && assignment.to_date) {
          await handleShiftRowSave(assignment); // ← Calls existing save function
        }
      }
    } else if (activeTab === "weekoff") {
      // Loop through all weekoff assignments and save each one
      for (const assignment of userWeekoffAssignments) {
        if (
          assignment.from_date &&
          assignment.to_date &&
          assignment.weekoff_days?.length > 0
        ) {
          await handleWeekoffRowSave(assignment); // ← Calls existing save function
        }
      }
    }
  };

  const toggleWeekoffDay = (index, dayValue) => {
    setUserWeekoffAssignments((prev) => {
      const updated = [...prev];

      let currentWeekoffDays = [];

      // Handle string format from API like "1,7"
      if (
        typeof updated[index].weekoff_days === "string" &&
        updated[index].weekoff_days
      ) {
        currentWeekoffDays = updated[index].weekoff_days
          .split(",")
          .map((d) => parseInt(d.trim(), 10));
      }
      // Handle array format
      else if (Array.isArray(updated[index].weekoff_days)) {
        currentWeekoffDays = [...updated[index].weekoff_days];
      }

      const dayExists = currentWeekoffDays.includes(dayValue);

      updated[index] = {
        ...updated[index],
        weekoff_days: dayExists
          ? currentWeekoffDays.filter((d) => d !== dayValue)
          : [...currentWeekoffDays, dayValue],
      };

      return updated;
    });
  };

  const toggleDevice = (deviceId) => {
    setForm((prev) => {
      const deviceIdString = String(deviceId);

      const alreadySelected = prev.devices.some(
        (id) => String(id) === deviceIdString,
      );

      return {
        ...prev,
        devices: alreadySelected
          ? prev.devices.filter((id) => String(id) !== deviceIdString)
          : [...prev.devices, deviceId],
      };
    });
  };

  const removeDevice = (deviceId) => {
    setForm((prev) => ({
      ...prev,
      devices: prev.devices.filter((id) => String(id) !== String(deviceId)),
    }));
  };

  const filteredDevices = devices.filter((device) => {
    const search = deviceSearch.toLowerCase().trim();

    if (!search) return true;

    return (
      String(device.device_name || "")
        .toLowerCase()
        .includes(search) ||
      String(device.name || "")
        .toLowerCase()
        .includes(search) ||
      String(device.id || "")
        .toLowerCase()
        .includes(search)
    );
  });

  const templateHeaders = [
    "company_id",
    "employee_code",
    "first_name",
    "last_name",
    "email_id",
    "country_code",
    "mobile_no",
    "password",
    "role",
    "desktop_access",
    "mobile_punchin_access",
    "department",
    "designation",
    "location",
    "reporting_manager",
    "gender",
  ];

  const downloadUserTemplate = async (includeUserData = false) => {
    if (!companyId || !isAuthenticated) return;

    try {
      setIsTemplateDownloading(true);
      showLoader("master");
      const [templateLocations, templateDepartments, templateDesignations] =
        await loadImportDropdowns();

      const workbook = new ExcelJS.Workbook();
      const usersSheet = workbook.addWorksheet("Users");
      const designationSheet = workbook.addWorksheet("Designations");
      const departmentSheet = workbook.addWorksheet("Departments");
      const locationSheet = workbook.addWorksheet("Locations");
      const managerSheet = workbook.addWorksheet("Reporting Managers");

      // Sheet 1 mirrors the /user/add request body. company_id is supplied
      // from the authenticated company when the spreadsheet is imported.
      usersSheet.addRow(templateHeaders);
      usersSheet.getRow(1).font = { bold: true, color: { argb: "FFFFFFFF" } };
      usersSheet.getRow(1).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF3867D6" },
      };
      usersSheet.views = [{ state: "frozen", ySplit: 1 }];
      usersSheet.columns = templateHeaders.map((header) => ({
        header,
        key: header,
        width: Math.max(header.length + 4, 18),
      }));

      designationSheet.addRow(["ID", "Designation", "Dropdown Value"]);
      templateDesignations.forEach((item) =>
        designationSheet.addRow([
          item.id,
          item.designation_name,
          `${item.id} | ${item.designation_name}`,
        ]),
      );
      designationSheet.columns = [
        { width: 12 },
        { width: 28 },
        { hidden: true },
      ];

      departmentSheet.addRow(["ID", "Department", "Dropdown Value"]);
      templateDepartments.forEach((item) =>
        departmentSheet.addRow([
          item.id,
          item.department_name,
          `${item.id} | ${item.department_name}`,
        ]),
      );
      departmentSheet.columns = [
        { width: 12 },
        { width: 28 },
        { hidden: true },
      ];

      locationSheet.addRow(["ID", "Location", "Dropdown Value"]);
      templateLocations.forEach((item) =>
        locationSheet.addRow([
          item.id,
          item.location_name,
          `${item.id} | ${item.location_name}`,
        ]),
      );
      locationSheet.columns = [{ width: 12 }, { width: 28 }, { hidden: true }];

      managerSheet.addRow(["ID", "Reporting Manager", "Dropdown Value"]);
      users.forEach((item) => {
        const managerName = `${item.first_name || ""} ${item.last_name || ""}`.trim();
        managerSheet.addRow([item.id, managerName, `${item.id} | ${managerName}`]);
      });
      managerSheet.columns = [{ width: 12 }, { width: 30 }, { hidden: true }];

      [designationSheet, departmentSheet, locationSheet, managerSheet]
        .filter(Boolean)
        .forEach((sheet) => {
        sheet.getRow(1).font = { bold: true };
        sheet.views = [{ state: "frozen", ySplit: 1 }];
        });

      const designationEnd = Math.max(templateDesignations.length + 1, 2);
      const departmentEnd = Math.max(templateDepartments.length + 1, 2);
      const locationEnd = Math.max(templateLocations.length + 1, 2);
      const validationSettings = (formula1) => ({
        type: "list",
        allowBlank: true,
        formulae: [formula1],
        showErrorMessage: true,
        errorTitle: "Select a listed value",
        error: "Please choose a value from the drop-down list.",
      });

      // Excel validation lists must use named ranges when their source is on
      // another sheet; direct cross-sheet formulas are removed by Excel.
      workbook.definedNames.add(
        "Designations!$C$2:$C$" + designationEnd,
        "DesignationOptions",
      );
      workbook.definedNames.add(
        "Departments!$C$2:$C$" + departmentEnd,
        "DepartmentOptions",
      );
      workbook.definedNames.add(
        "Locations!$C$2:$C$" + locationEnd,
        "LocationOptions",
      );
      const managerEnd = Math.max(users.length + 1, 2);
      workbook.definedNames.add(
        "'Reporting Managers'!$C$2:$C$" + managerEnd,
        "ManagerOptions",
      );

      usersSheet.dataValidations.add(
        "I2:I501",
        validationSettings('"0 | User,1 | Admin"'),
      );
      usersSheet.dataValidations.add(
        "J2:J501",
        validationSettings('"0 | No,1 | Yes"'),
      );
      usersSheet.dataValidations.add(
        "K2:K501",
        validationSettings('"0 | No,1 | Yes"'),
      );
      usersSheet.dataValidations.add(
        "L2:L501",
        validationSettings("DepartmentOptions"),
      );
      usersSheet.dataValidations.add(
        "M2:M501",
        validationSettings("DesignationOptions"),
      );
      usersSheet.dataValidations.add(
        "N2:N501",
        validationSettings("LocationOptions"),
      );
      usersSheet.dataValidations.add(
        "O2:O501",
        validationSettings("ManagerOptions"),
      );
      usersSheet.dataValidations.add(
        "P2:P501",
        validationSettings('"Male,Female,Other"'),
      );

      if (includeUserData) {
        const masterLabel = (items, id, field) => {
          const item = items.find((master) => Number(master.id) === Number(id));
          return item ? `${item.id} | ${item[field]}` : String(id || "");
        };
        const reportingManagerLabel = (id) => {
          const manager = users.find((item) => Number(item.id) === Number(id));
          if (!manager) return String(id || "");
          const name = `${manager.first_name || ""} ${manager.last_name || ""}`.trim();
          return `${manager.id} | ${name}`;
        };
        const userDetails = await Promise.all(
          users.map(async (listedUser) => {
            try {
              const response = await api.get(
                `/user/${listedUser.id}/${companyId}`,
              );
              return response.json();
            } catch (error) {
              console.error("Unable to load user for export", {
                userId: listedUser.id,
                error: error.message,
              });
              return null;
            }
          }),
        );

        userDetails.filter(Boolean).forEach((userData) => {
          usersSheet.addRow([
            userData.company_id || companyId,
            userData.employee_code || "",
            userData.first_name || "",
            userData.last_name || "",
            userData.email_id || "",
            userData.country_code || "",
            userData.mobile_no || "",
            userData.password || "",
            `${Number(userData.role) || 0} | ${Number(userData.role) === 1 ? "Admin" : "User"}`,
            `${Number(userData.desktop_access) || 0} | ${Number(userData.desktop_access) === 1 ? "Yes" : "No"}`,
            `${Number(userData.is_allow_mobilepunch) || 0} | ${Number(userData.is_allow_mobilepunch) === 1 ? "Yes" : "No"}`,
            masterLabel(
              templateDepartments,
              userData.department,
              "department_name",
            ),
            masterLabel(
              templateDesignations,
              userData.designation,
              "designation_name",
            ),
            masterLabel(templateLocations, userData.location, "location_name"),
            reportingManagerLabel(userData.reporting_manager),
            userData.gender || "",
          ]);
        });
      }

      const fileData = await workbook.xlsx.writeBuffer();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(
        new Blob([fileData], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
      );
      link.download = includeUserData
        ? "User_List_With_Data.xlsx"
        : "User_Import_Template.xlsx";
      link.click();
      URL.revokeObjectURL(link.href);
      toast.success(
        includeUserData
          ? "User list downloaded with data"
          : "Blank user import template downloaded",
      );
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Unable to download template");
    } finally {
      hideLoader();
      setIsTemplateDownloading(false);
      setShowDownloadChoice(false);
    }
  };

  const handleImportUsers = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file || !companyId || !isAuthenticated) return;

    try {
      setIsImportPreparing(true);
      showLoader("master");
      const [importLocations, importDepartments, importDesignations] =
        await loadImportDropdowns();
      const fileData = await file.arrayBuffer();
      const workbook = XLSX.read(fileData, { type: "array" });
      const usersSheet =
        workbook.Sheets.Users || workbook.Sheets[workbook.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(usersSheet, { defval: "" });

      if (!rows.length) {
        throw new Error("The Users sheet has no user rows to import");
      }

      const lookupId = (items, value, field) => {
        const selectedId = String(value || "")
          .split("|")[0]
          .trim();
        const idMatch = items.find((item) => String(item.id) === selectedId);
        if (idMatch) return idMatch.id;

        const match = items.find(
          (item) =>
            String(item[field] || "")
              .trim()
              .toLowerCase() ===
            String(value || "")
              .trim()
              .toLowerCase(),
        );
        return match?.id;
      };
      const selectedNumericId = (value) => {
        const selectedId = String(value || "")
          .split("|")[0]
          .trim();
        return /^\d+$/.test(selectedId) ? Number(selectedId) : null;
      };
      const masterLabel = (items, id, field) => {
        const item = items.find((master) => Number(master.id) === Number(id));
        return item ? `${item.id} | ${item[field]}` : String(id);
      };
      const managers = users;
      const invalidRows = [];
      const validRows = [];

      for (let index = 0; index < rows.length; index += 1) {
        const row = rows[index];
        const rowNumber = index + 2;
        const firstName = String(row.first_name || "").trim();
        const lastName = String(row.last_name || "").trim();
        const email = String(row.email_id || "").trim();
        const password = String(row.password || "");
        const department = lookupId(
          importDepartments,
          row.department,
          "department_name",
        );
        const designation = lookupId(
          importDesignations,
          row.designation,
          "designation_name",
        );
        const location = lookupId(
          importLocations,
          row.location,
          "location_name",
        );
        const reportingManager = selectedNumericId(row.reporting_manager);
        const roleValue = selectedNumericId(row.role);
        const desktopValue = selectedNumericId(row.desktop_access);
        // Older templates have no mobile punch-in column; treat blank as "No".
        const mobilePunchValue = String(row.mobile_punchin_access ?? "").trim()
          ? selectedNumericId(row.mobile_punchin_access)
          : 0;
        const gender = String(row.gender || "").trim();
        const isValidGender = ["male", "female", "other"].includes(
          gender.toLowerCase(),
        );
        const isValidRole = [0, 1].includes(roleValue);
        const isValidDesktopAccess = [0, 1].includes(desktopValue);
        const isValidMobilePunch = [0, 1].includes(mobilePunchValue);

        if (
          !firstName ||
          !lastName ||
          !email ||
          !password ||
          !department ||
          !designation ||
          !location ||
          !reportingManager ||
          !isValidGender ||
          !isValidRole ||
          !isValidDesktopAccess ||
          !isValidMobilePunch
        ) {
          console.warn("User import skipped: invalid row", {
            rowNumber,
            firstName,
            lastName,
            email,
            department,
            designation,
            location,
            reportingManager,
            roleValue,
            desktopValue,
            mobilePunchValue,
            gender,
            // Password is deliberately excluded from browser logs.
          });
          invalidRows.push({
            rowNumber,
            reason: "Missing or invalid required value",
          });
          continue;
        }

        const payload = {
          company_id: companyId,
          employee_code: String(row.employee_code || "").trim(),
          first_name: firstName,
          last_name: lastName,
          email_id: email,
          country_code: String(row.country_code || "+91").trim(),
          mobile_no: String(row.mobile_no || "").trim(),
          password,
          role: roleValue,
          desktop_access: desktopValue,
          is_allow_mobilepunch: mobilePunchValue,
          department: Number(department),
          designation: Number(designation),
          location: Number(location),
          reporting_manager: Number(reportingManager),
          gender,
          device_allowed: [],
        };

        const debugPayload = { ...payload, password: "[REDACTED]" };
        console.info("User import: row ready for confirmation", {
          rowNumber,
          payload: debugPayload,
        });
        validRows.push({
          rowNumber,
          payload,
          departmentLabel: masterLabel(
            importDepartments,
            department,
            "department_name",
          ),
          designationLabel: masterLabel(
            importDesignations,
            designation,
            "designation_name",
          ),
          locationLabel: masterLabel(
            importLocations,
            location,
            "location_name",
          ),
        });
      }

      setImportPreview({ validRows, invalidRows });
      if (!validRows.length) {
        toast.error("No valid users were found in the selected file");
      }
    } catch (error) {
      console.error("User import failed before completion", error);
      toast.error(error.message || "Unable to import users");
    } finally {
      hideLoader();
      setIsImportPreparing(false);
    }
  };

  const confirmUserImport = async () => {
    if (!importPreview?.validRows.length) return;

    const failedRows = [...importPreview.invalidRows];
    let imported = 0;

    try {
      setIsImportSubmitting(true);
      setImportProgress({ current: 0, total: importPreview.validRows.length });

      for (const { rowNumber, payload } of importPreview.validRows) {
        const debugPayload = { ...payload, password: "[REDACTED]" };
        console.info("User import: sending confirmed row", {
          rowNumber,
          payload: debugPayload,
        });

        try {
          const response = await api.post(`/user/add`, payload);
          const result = await response.json();

          if (result?.status === false) {
            throw new Error(result.message || "User creation was rejected");
          }

          console.info("User import: row created", { rowNumber, result });
          imported += 1;
        } catch (rowError) {
          console.error("User import: API request failed", {
            rowNumber,
            payload: debugPayload,
            error: rowError.message,
          });
          failedRows.push({ rowNumber, reason: rowError.message });
        } finally {
          setImportProgress((previous) => ({
            ...previous,
            current: previous.current + 1,
          }));
        }
      }

      await fetchUsers();
      if (imported) {
        toast.success(
          `${imported} user${imported === 1 ? "" : "s"} imported successfully`,
        );
      }
      if (failedRows.length) {
        toast.error(`${failedRows.length} row(s) could not be imported. `);
      }
      setImportPreview(null);
    } catch (error) {
      console.error("User import confirmation failed", error);
      toast.error(error.message || "Unable to import users");
    } finally {
      setIsImportSubmitting(false);
    }
  };

  return (
    <div className="user-master-container">
      <PageHeading>User List Master</PageHeading>
      {showDownloadChoice && (
        <div className="download-choice-backdrop" role="dialog" aria-modal="true">
          <div className="download-choice-modal">
            <h3>Download User Template</h3>
            <p>Choose whether to download a blank template or include all existing users.</p>
            <div className="download-choice-actions">
              <button
                type="button"
                className="user-action-btn"
                disabled={isTemplateDownloading}
                onClick={() => downloadUserTemplate(false)}
              >
                {isTemplateDownloading ? "Preparing..." : "Without Data"}
              </button>
              <button
                type="button"
                className="add-user-btn"
                disabled={isTemplateDownloading}
                onClick={() => downloadUserTemplate(true)}
              >
                {isTemplateDownloading ? "Preparing..." : "With Data"}
              </button>
            </div>
            <button
              type="button"
              className="download-choice-cancel"
              disabled={isTemplateDownloading}
              onClick={() => setShowDownloadChoice(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
      {!showForm ? (
        importPreview ? (
          <div className="import-preview-container">
            <div className="import-preview-header">
              <div>
                <h3>Review User Import</h3>
                <p>
                  No users have been created yet. Confirm to create the valid
                  rows below.
                </p>
              </div>
              <div className="import-preview-summary">
                <span className="preview-valid-count">
                  {importPreview.validRows.length} ready
                </span>
                <span className="preview-invalid-count">
                  {importPreview.invalidRows.length} invalid
                </span>
              </div>
            </div>

            {isImportSubmitting && (
              <div className="import-progress" aria-live="polite">
                <div className="import-progress-label">
                  <span>
                    Creating users: {importProgress.current} of {importProgress.total}
                  </span>
                  <strong>
                    {importProgress.total
                      ? Math.round((importProgress.current / importProgress.total) * 100)
                      : 0}
                    %
                  </strong>
                </div>
                <div className="import-progress-track">
                  <div
                    className="import-progress-fill"
                    style={{
                      width: `${
                        importProgress.total
                          ? (importProgress.current / importProgress.total) * 100
                          : 0
                      }%`,
                    }}
                  />
                </div>
              </div>
            )}

            <div className="import-preview-table-wrapper">
              <table className="import-preview-table">
                <thead>
                  <tr>
                    <th>Excel Row</th>
                    <th>Employee Code</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Department ID</th>
                    <th>Designation ID</th>
                    <th>Location ID</th>
                    <th>Mobile Punchin Access</th>
                  </tr>
                </thead>
                <tbody>
                  {importPreview.validRows.map(
                    ({
                      rowNumber,
                      payload,
                      departmentLabel,
                      designationLabel,
                      locationLabel,
                    }) => (
                      <tr key={rowNumber}>
                        <td>{rowNumber}</td>
                        <td>{payload.employee_code || "—"}</td>
                        <td>
                          {payload.first_name} {payload.last_name}
                        </td>
                        <td>{payload.email_id}</td>
                        <td>{departmentLabel}</td>
                        <td>{designationLabel}</td>
                        <td>{locationLabel}</td>
                        <td>
                          {payload.is_allow_mobilepunch === 1 ? "Yes" : "No"}
                        </td>
                      </tr>
                    ),
                  )}
                  {importPreview.invalidRows.map(({ rowNumber, reason }) => (
                    <tr
                      key={`invalid-${rowNumber}`}
                      className="invalid-import-row"
                    >
                      <td>{rowNumber}</td>
                      <td colSpan="7">Not ready: {reason}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="import-preview-actions">
              <button
                type="button"
                className="cancel-btn"
                disabled={isImportSubmitting}
                onClick={() => setImportPreview(null)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="save-btn"
                disabled={!importPreview.validRows.length || isImportSubmitting}
                onClick={confirmUserImport}
              >
                {isImportSubmitting ? "Creating Users..." : "Confirm Import"}
              </button>
            </div>
          </div>
        ) : (
          <>
            <div className="user-master-top">
              <button
                className="user-action-btn template-btn"
                disabled={isTemplateDownloading}
                onClick={() => setShowDownloadChoice(true)}
              >
                Download Template
              </button>
              <button
                className="user-action-btn import-user-btn"
                disabled={isImportPreparing}
                onClick={() => importInputRef.current?.click()}
              >
                {isImportPreparing ? "Preparing Import..." : "Import User"}
              </button>
              <input
                ref={importInputRef}
                type="file"
                accept=".xlsx,.xls"
                className="import-file-input"
                onChange={handleImportUsers}
              />
              <button
                className="add-user-btn"
                onClick={async () => {
                  await loadDropdowns();

                  setActiveTab("personal");
                  setEditId(null);

                  setForm({
                    employee_code: "",
                    first_name: "",
                    last_name: "",
                    gender: "",
                    email_id: "",
                    country_code: "+91",
                    mobile_no: "",
                    password: "",
                    role: "",
                    desktop_access: "",
                    mobile_punchin_access: "",
                    department: "",
                    designation: "",
                    location: "",
                    reporting_manager: "",
                    devices: [],
                    status: true,
                  });

                  setDeviceSearch("");
                  setShowDeviceDropdown(false);

                  setShowForm(true);
                }}
              >
                + Add User
              </button>
            </div>

            <div className="user-table-wrapper">
              <table className="user-table">
                <thead>
                  <tr>
                    <th className="serial-col">Sr.No</th>
                    <th className="emp-code-col">Employee Code</th>
                    <th>Name</th>
                    <th>Email</th>

                    <th className="status-col">Status</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {users.map((item, index) => (
                    <tr key={item.id}>
                      <td className="serial-col">{index + 1}</td>

                      <td className="emp-code-col">{item.employee_code}</td>

                      <td>
                        {item.first_name} {item.last_name}
                      </td>

                      <td>{item.email_id}</td>

                      <td className="status-col">
                        <label className="switch">
                          <input
                            type="checkbox"
                            checked={item.isactive === 1}
                            onChange={() => toggleStatus(item)}
                          />
                          <span className="slider"></span>
                        </label>
                      </td>

                      <td className="action-cell">
                        <FaRegEdit
                          className="edit-icon"
                          onClick={() => handleEdit(item)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )
      ) : (
        <div className="user-form-container">
          <div className="user-form-header">
            <img
              src={back}
              alt="Back"
              className="back-btn-img"
              onClick={handleCancel}
            />

            <h3>{editId ? "Edit User" : "Add User"}</h3>
          </div>

          {editId && (
            <div className="user-tabs">
              <button
                className={
                  activeTab === "personal" ? "tab-btn active" : "tab-btn"
                }
                onClick={() => setActiveTab("personal")}
              >
                Personal Details
              </button>

              <button
                className={activeTab === "shift" ? "tab-btn active" : "tab-btn"}
                onClick={async () => {
                  setActiveTab("shift");

                  if (shifts.length === 0) {
                    await fetchShifts();
                  }

                  if (editId) {
                    const today = new Date();

                    const firstDay = new Date(
                      today.getFullYear(),
                      today.getMonth(),
                      1,
                    );

                    const lastDay = new Date(
                      today.getFullYear(),
                      today.getMonth() + 1,
                      0,
                    );

                    const formatDate = (date) => {
                      const year = date.getFullYear();
                      const month = String(date.getMonth() + 1).padStart(
                        2,
                        "0",
                      );
                      const day = String(date.getDate()).padStart(2, "0");

                      return `${year}-${month}-${day}`;
                    };

                    const fromDate = formatDate(firstDay);
                    const toDate = formatDate(lastDay);

                    setShiftFilter({
                      from_date: fromDate,
                      to_date: toDate,
                    });

                    await fetchUserShiftAssignments(editId, fromDate, toDate);
                  }
                }}
              >
                Shift Assignment
              </button>

              <button
                className={
                  activeTab === "weekoff" ? "tab-btn active" : "tab-btn"
                }
                onClick={async () => {
                  setActiveTab("weekoff");

                  if (editId) {
                    const today = new Date();

                    const firstDay = new Date(
                      today.getFullYear(),
                      today.getMonth(),
                      1,
                    );

                    const lastDay = new Date(
                      today.getFullYear(),
                      today.getMonth() + 1,
                      0,
                    );

                    const formatDate = (date) => {
                      const year = date.getFullYear();
                      const month = String(date.getMonth() + 1).padStart(
                        2,
                        "0",
                      );
                      const day = String(date.getDate()).padStart(2, "0");

                      return `${year}-${month}-${day}`;
                    };

                    const fromDate = formatDate(firstDay);
                    const toDate = formatDate(lastDay);

                    setWeekoffFilter({
                      from_date: fromDate,
                      to_date: toDate,
                    });

                    await fetchUserWeekoffAssignments(editId, fromDate, toDate);
                  }
                }}
              >
                Weekoff Assignment
              </button>
            </div>
          )}

          {activeTab === "personal" && (
            <div className="user-form">
              <div className="user-field-group">
                <label>
                  Employee Code <span>*</span>
                </label>

                <input
                  type="text"
                  value={form.employee_code}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      employee_code: e.target.value,
                    })
                  }
                  placeholder="Employee Code"
                />
              </div>

              <div className="user-field-group">
                <label>
                  First Name <span>*</span>
                </label>

                <input
                  type="text"
                  value={form.first_name}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      first_name: e.target.value,
                    })
                  }
                  placeholder="First Name"
                />
              </div>

              <div className="user-field-group">
                <label>
                  Last Name <span>*</span>
                </label>

                <input
                  type="text"
                  value={form.last_name}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      last_name: e.target.value,
                    })
                  }
                  placeholder="Last Name"
                />
              </div>

              <div className="user-field-group">
                <label>
                  Gender <span>*</span>
                </label>

                <select
                  value={form.gender}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      gender: e.target.value,
                    })
                  }
                >
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              <div className="user-field-group">
                <label>
                  Email ID <span>*</span>
                </label>

                <input
                  type="email"
                  value={form.email_id}
                  onChange={(e) => {
                    const value = e.target.value;

                    // Allow only valid email characters
                    if (/^[A-Za-z0-9@._%+-]*$/.test(value)) {
                      setForm({
                        ...form,
                        email_id: value,
                      });
                    }
                  }}
                  placeholder="Email Address"
                />
              </div>

              <div className="user-field-group">
                <label>
                  Mobile Number <span>*</span>
                </label>

                <PhoneInput
                  country={"in"}
                  value={`${form.country_code.replace("+", "")}${form.mobile_no}`}
                  onChange={(value, country) => {
                    const dialCode = `+${country.dialCode}`;

                    setForm({
                      ...form,
                      country_code: dialCode,
                      mobile_no: value.slice(country.dialCode.length),
                    });
                  }}
                  inputStyle={{
                    width: "100%",
                    height: "46px",
                    border: "1px solid #cfd6df",
                    borderRadius: "4px",
                    fontSize: "14px",
                  }}
                  containerStyle={{
                    width: "100%",
                  }}
                  buttonStyle={{
                    border: "1px solid #cfd6df",
                    borderRight: "none",
                  }}
                />
              </div>

              <div className="user-field-group">
                <label>
                  Password <span>*</span>
                </label>

                <div className="password-input-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={form.password}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        password: e.target.value,
                      })
                    }
                    placeholder="Password"
                  />

                  <button
                    type="button"
                    className="password-toggle-btn"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FaEye /> : <FaEyeSlash />}
                  </button>
                </div>
              </div>

              <div className="user-field-group">
                <label>
                  Role <span>*</span>
                </label>

                <select
                  value={String(form.role)}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      role: e.target.value,
                    })
                  }
                >
                  <option value="">Select Role</option>
                  <option value="1">Admin</option>
                  <option value="0">User</option>
                </select>
              </div>

              <div className="user-field-group">
                <label>
                  Desktop Access <span>*</span>
                </label>

                <select
                  value={String(form.desktop_access ?? "")}
                  onChange={(e) => {
                    setForm((prev) => ({
                      ...prev,
                      desktop_access: e.target.value,
                    }));
                  }}
                >
                  <option value="">Select Desktop Access</option>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </div>

              <div className="user-field-group">
                <label htmlFor="mobile-punchin-access">
                  Mobile Punchin access <span>*</span>
                </label>

                <select
                  id="mobile-punchin-access"
                  value={String(form.mobile_punchin_access ?? "")}
                  onChange={(e) =>
                    setForm((prev) => ({
                      ...prev,
                      mobile_punchin_access: e.target.value,
                    }))
                  }
                >
                  <option value="">Select Mobile Punchin access</option>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </div>

              <div className="user-field-group">
                <label>
                  Department <span>*</span>
                </label>

                <select
                  value={String(form.department || "")}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      department: e.target.value,
                    })
                  }
                >
                  <option value="">Select Department</option>

                  {departments.map((department) => (
                    <option key={department.id} value={String(department.id)}>
                      {department.department_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="user-field-group">
                <label>
                  Designation <span>*</span>
                </label>

                <select
                  value={String(form.designation || "")}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      designation: e.target.value,
                    })
                  }
                >
                  <option value="">Select Designation</option>

                  {designations.map((designation) => (
                    <option key={designation.id} value={String(designation.id)}>
                      {designation.designation_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="user-field-group">
                <label>
                  Location <span>*</span>
                </label>

                <select
                  value={String(form.location || "")}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      location: e.target.value,
                    })
                  }
                >
                  <option value="">Select Location</option>

                  {locations.map((location) => (
                    <option key={location.id} value={String(location.id)}>
                      {location.location_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="user-field-group device-field">
                <label>Devices</label>

                <div className="device-multiselect" ref={deviceDropdownRef}>
                  {/* Selected devices */}
                  <div
                    className="device-input"
                    // onClick={() => {
                    //   setShowDeviceDropdown((prev) => !prev);
                    //   setDeviceSearch("");
                    // }}
                    onClick={handleDeviceDropdownToggle}
                  >
                    {form.devices.length === 0 ? (
                      <span className="device-placeholder">Select Devices</span>
                    ) : (
                      <div className="selected-devices">
                        {form.devices.map((deviceId) => {
                          const device = devices.find(
                            (d) => String(d.id) === String(deviceId),
                          );

                          if (!device) return null;

                          const deviceName =
                            device.device_name || `Device ${device.id}`;

                          return (
                            <span key={device.id} className="device-tag">
                              {deviceName}

                              <button
                                type="button"
                                className="device-remove"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  removeDevice(device.id);
                                }}
                              >
                                ×
                              </button>
                            </span>
                          );
                        })}
                      </div>
                    )}
                  </div>

                  {/* Dropdown */}
                  {showDeviceDropdown && (
                    <div className="device-dropdown">
                      {/* Device list */}
                      <div className="device-options">
                        {filteredDevices.length === 0 ? (
                          <div className="device-no-results">
                            No devices found
                          </div>
                        ) : (
                          filteredDevices.map((device) => {
                            const selected = form.devices.some(
                              (id) => String(id) === String(device.id),
                            );

                            const deviceName =
                              device.device_name || `Device ${device.id}`;

                            return (
                              <div
                                key={device.id}
                                className={`device-option ${
                                  selected ? "selected" : ""
                                }`}
                                onClick={() => toggleDevice(device.id)}
                              >
                                <span>{deviceName}</span>
                              </div>
                            );
                          })
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="user-field-group">
                <label>
                  Reporting Manager <span>*</span>
                </label>

                <select
                  value={form.reporting_manager || ""}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      reporting_manager: e.target.value,
                    })
                  }
                >
                  <option value="">Select Reporting Manager</option>

                  {users
                    .filter((manager) => Number(manager.id) !== Number(editId))
                    .map((manager) => (
                      <option key={manager.id} value={manager.id}>
                        {manager.first_name} {manager.last_name}
                      </option>
                    ))}
                </select>
              </div>

              {editId && (
                <div className="user-field-group">
                  <label>Status</label>

                  <select
                    value={form.status ? "Active" : "Inactive"}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        status: e.target.value === "Active",
                      })
                    }
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </div>
              )}
            </div>
          )}

          {activeTab === "shift" && (
            <div className="shift-assignment-section">
              <div className="shift-table-header">
                {/* LEFT SIDE - DATE FILTER */}
                <div className="shift-filter">
                  <div className="shift-filter-field">
                    <label>From Date</label>

                    <div className="shift-filter-date-wrapper">
                      <input
                        type="text"
                        className="shift-filter-date-display"
                        value={
                          shiftFilter.from_date
                            ? shiftFilter.from_date
                                .split("-")
                                .reverse()
                                .join("-")
                            : ""
                        }
                        placeholder="dd-mm-yyyy"
                        readOnly
                        onClick={() => {
                          shiftFromDateRef.current?.showPicker();
                        }}
                      />

                      <FiCalendar
                        className="shift-filter-calendar-icon"
                        onClick={() => {
                          shiftFromDateRef.current?.showPicker();
                        }}
                      />

                      <input
                        ref={shiftFromDateRef}
                        type="date"
                        className="shift-filter-date-picker"
                        min="2000-01-01"
                        max="2099-12-31"
                        value={shiftFilter.from_date}
                        onChange={(e) =>
                          setShiftFilter((prev) => ({
                            ...prev,
                            from_date: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>

                  <div className="shift-filter-field">
                    <label>To Date</label>

                    <div className="shift-filter-date-wrapper">
                      {/* Visible DD-MM-YYYY field */}
                      <input
                        type="text"
                        className="shift-filter-date-display"
                        value={
                          shiftFilter.to_date
                            ? shiftFilter.to_date.split("-").reverse().join("-")
                            : ""
                        }
                        placeholder="dd-mm-yyyy"
                        readOnly
                        onClick={() => {
                          shiftToDateRef.current?.showPicker();
                        }}
                      />

                      {/* Black / white outline calendar */}
                      <FiCalendar
                        className="shift-filter-calendar-icon"
                        onClick={() => {
                          shiftToDateRef.current?.showPicker();
                        }}
                      />

                      {/* Hidden native date picker */}
                      <input
                        ref={shiftToDateRef}
                        type="date"
                        className="shift-filter-date-picker"
                        min="2000-01-01"
                        max="2099-12-31"
                        value={shiftFilter.to_date}
                        onChange={(e) =>
                          setShiftFilter((prev) => ({
                            ...prev,
                            to_date: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>

                  <button
                    type="button"
                    className="shift-filter-btn"
                    onClick={handleShiftFilter}
                  >
                    Search
                  </button>
                </div>

                {/* RIGHT SIDE - ADD */}
                <button
                  type="button"
                  className="add-shift-btn"
                  onClick={() => {
                    setUserShiftAssignments((prev) => [
                      ...prev,
                      {
                        assignment_id: null,
                        shift_id: "",
                        from_date: "",
                        to_date: "",
                        isactive: 1,
                      },
                    ]);
                  }}
                >
                  + Add
                </button>
              </div>

              <div className="shift-table-wrapper">
                <table className="shift-table">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Shift Name</th>
                      <th>From Date</th>
                      <th>To Date</th>
                      <th className="shift-status-col">Status</th>
                      <th className="shift-action-col">Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {shiftLoading ? (
                      <tr>
                        <td colSpan="6" className="no-shift-data">
                          Loading...
                        </td>
                      </tr>
                    ) : userShiftAssignments.length > 0 ? (
                      userShiftAssignments.map((assignment, index) => (
                        <tr key={assignment.assignment_id || `new-${index}`}>
                          {/* Sr. No. */}
                          <td className="shift-serial-col">{index + 1}</td>

                          {/* Shift Name */}
                          <td>
                            <select
                              value={assignment.shift_id || ""}
                              onChange={(e) => {
                                const updated = [...userShiftAssignments];

                                updated[index] = {
                                  ...updated[index],
                                  shift_id: e.target.value
                                    ? Number(e.target.value)
                                    : "",
                                };

                                setUserShiftAssignments(updated);
                              }}
                            >
                              <option value="">Select Shift</option>

                              {shifts.map((shift) => (
                                <option key={shift.id} value={String(shift.id)}>
                                  {shift.shift_name}
                                </option>
                              ))}
                            </select>
                          </td>

                          {/* From Date */}
                          <td>
                            <div className="shift-assignment-date-wrapper">
                              {/* Visible DD-MM-YYYY field */}
                              <input
                                type="text"
                                className="shift-assignment-date-display"
                                value={
                                  assignment.from_date
                                    ? assignment.from_date
                                        .split("-")
                                        .reverse()
                                        .join("-")
                                    : ""
                                }
                                placeholder="dd-mm-yyyy"
                                readOnly
                                onClick={() => {
                                  shiftAssignmentFromDateRefs.current[
                                    index
                                  ]?.showPicker();
                                }}
                              />

                              {/* Black / white outline calendar */}
                              <FiCalendar
                                className="shift-assignment-calendar-icon"
                                onClick={() => {
                                  shiftAssignmentFromDateRefs.current[
                                    index
                                  ]?.showPicker();
                                }}
                              />

                              {/* Hidden native date picker */}
                              <input
                                ref={(el) => {
                                  shiftAssignmentFromDateRefs.current[index] =
                                    el;
                                }}
                                type="date"
                                className="shift-assignment-date-picker"
                                min="2000-01-01"
                                max="2099-12-31"
                                value={assignment.from_date || ""}
                                onChange={(e) => {
                                  const updated = [...userShiftAssignments];

                                  updated[index] = {
                                    ...updated[index],
                                    from_date: e.target.value,
                                  };

                                  setUserShiftAssignments(updated);
                                }}
                              />
                            </div>
                          </td>

                          {/* To Date */}
                          <td>
                            <div className="shift-assignment-date-wrapper">
                              {/* Visible DD-MM-YYYY field */}
                              <input
                                type="text"
                                className="shift-assignment-date-display"
                                value={
                                  assignment.to_date
                                    ? assignment.to_date
                                        .split("-")
                                        .reverse()
                                        .join("-")
                                    : ""
                                }
                                placeholder="dd-mm-yyyy"
                                readOnly
                                onClick={() => {
                                  shiftAssignmentToDateRefs.current[
                                    index
                                  ]?.showPicker();
                                }}
                              />

                              {/* Black / white outline calendar */}
                              <FiCalendar
                                className="shift-assignment-calendar-icon"
                                onClick={() => {
                                  shiftAssignmentToDateRefs.current[
                                    index
                                  ]?.showPicker();
                                }}
                              />

                              {/* Hidden native date picker */}
                              <input
                                ref={(el) => {
                                  shiftAssignmentToDateRefs.current[index] = el;
                                }}
                                type="date"
                                className="shift-assignment-date-picker"
                                min="2000-01-01"
                                max="2099-12-31"
                                value={assignment.to_date || ""}
                                onChange={(e) => {
                                  const updated = [...userShiftAssignments];

                                  updated[index] = {
                                    ...updated[index],
                                    to_date: e.target.value,
                                  };

                                  setUserShiftAssignments(updated);
                                }}
                              />
                            </div>
                          </td>

                          {/* Status */}
                          <td className="shift-status-col">
                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={Number(assignment.isactive) === 1}
                                onChange={(e) =>
                                  handleShiftStatusToggle(
                                    assignment,
                                    e.target.checked,
                                  )
                                }
                              />

                              <span className="slider"></span>
                            </label>
                          </td>

                          {/* Action */}
                          <td className="shift-action-col">
                            <button
                              type="button"
                              className="save-btn"
                              onClick={() => handleShiftRowSave(assignment)}
                            >
                              Save
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="no-shift-data">
                          No shift assignments found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {activeTab === "weekoff" && (
            <div className="weekoff-assignment-section">
              <div className="shift-table-header">
                {/* LEFT SIDE - DATE FILTER */}
                <div className="shift-filter">
                  <div className="shift-filter-field">
                    <label>From Date</label>

                    <div className="shift-filter-date-wrapper">
                      {/* Visible DD-MM-YYYY field */}
                      <input
                        type="text"
                        className="shift-filter-date-display"
                        value={
                          weekoffFilter.from_date
                            ? weekoffFilter.from_date
                                .split("-")
                                .reverse()
                                .join("-")
                            : ""
                        }
                        placeholder="dd-mm-yyyy"
                        readOnly
                        onClick={() => {
                          weekoffFromDateRef.current?.showPicker();
                        }}
                      />

                      {/* Black / white outline calendar */}
                      <FiCalendar
                        className="shift-filter-calendar-icon"
                        onClick={() => {
                          weekoffFromDateRef.current?.showPicker();
                        }}
                      />

                      {/* Hidden native date picker */}
                      <input
                        ref={weekoffFromDateRef}
                        type="date"
                        className="shift-filter-date-picker"
                        min="2000-01-01"
                        max="2099-12-31"
                        value={weekoffFilter.from_date}
                        onChange={(e) =>
                          setWeekoffFilter((prev) => ({
                            ...prev,
                            from_date: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>

                  <div className="shift-filter-field">
                    <label>To Date</label>

                    <div className="shift-filter-date-wrapper">
                      {/* Visible DD-MM-YYYY field */}
                      <input
                        type="text"
                        className="shift-filter-date-display"
                        value={
                          weekoffFilter.to_date
                            ? weekoffFilter.to_date
                                .split("-")
                                .reverse()
                                .join("-")
                            : ""
                        }
                        placeholder="dd-mm-yyyy"
                        readOnly
                        onClick={() => {
                          weekoffToDateRef.current?.showPicker();
                        }}
                      />

                      {/* Black / white outline calendar */}
                      <FiCalendar
                        className="shift-filter-calendar-icon"
                        onClick={() => {
                          weekoffToDateRef.current?.showPicker();
                        }}
                      />

                      {/* Hidden native date picker */}
                      <input
                        ref={weekoffToDateRef}
                        type="date"
                        className="shift-filter-date-picker"
                        min="2000-01-01"
                        max="2099-12-31"
                        value={weekoffFilter.to_date}
                        onChange={(e) =>
                          setWeekoffFilter((prev) => ({
                            ...prev,
                            to_date: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>

                  <button
                    type="button"
                    className="shift-filter-btn"
                    onClick={handleWeekoffFilter}
                  >
                    Search
                  </button>
                </div>

                {/* RIGHT SIDE - ADD */}
                <button
                  type="button"
                  className="add-shift-btn"
                  onClick={() => {
                    setUserWeekoffAssignments((prev) => [
                      ...prev,
                      {
                        assignment_id: null,
                        from_date: "",
                        to_date: "",
                        weekoff_days: [],
                        isactive: 1,
                      },
                    ]);
                  }}
                >
                  + Add
                </button>
              </div>

              <div className="shift-table-wrapper">
                <table className="shift-table">
                  <thead>
                    <tr>
                      <th className="weekoff-sr-col">Sr. No.</th>
                      <th className="weekoff-days-header">Weekoff Days</th>
                      <th className="weekoff-date-col">From Date</th>
                      <th className="weekoff-date-col">To Date</th>
                      <th className="shift-status-col">Status</th>
                      <th className="shift-action-col">Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {weekoffLoading ? (
                      <tr>
                        <td colSpan="6" className="no-shift-data">
                          Loading...
                        </td>
                      </tr>
                    ) : userWeekoffAssignments.length > 0 ? (
                      userWeekoffAssignments.map((assignment, index) => (
                        <tr key={assignment.assignment_id || `new-${index}`}>
                          {/* Sr. No. */}
                          <td className="weekoff-sr-col">{index + 1}</td>

                          {/* Weekoff Days - Checkboxes */}
                          <td className="weekoff-days-cell">
                            <div className="weekoff-checkboxes-compact">
                              {[
                                { label: "Sunday", value: 1 },
                                { label: "Monday", value: 2 },
                                { label: "Tueday", value: 3 },
                                { label: "Wedday", value: 4 },
                                { label: "Thuday", value: 5 },
                                { label: "Friday", value: 6 },
                                { label: "Saturday", value: 7 },
                              ].map((day) => {
                                const weekoffDays = assignment.weekoff_days;
                                let isChecked = false;

                                // Handle array format [1,7]
                                if (Array.isArray(weekoffDays)) {
                                  isChecked = weekoffDays.includes(day.value);
                                }
                                // Handle string format like "1,7"
                                else if (
                                  typeof weekoffDays === "string" &&
                                  weekoffDays
                                ) {
                                  const daysArray = weekoffDays
                                    .split(",")
                                    .map((d) => parseInt(d.trim(), 10));
                                  isChecked = daysArray.includes(day.value);
                                }

                                return (
                                  <label
                                    key={day.value}
                                    className="weekoff-checkbox-compact"
                                  >
                                    <input
                                      type="checkbox"
                                      checked={isChecked || false}
                                      onChange={() =>
                                        toggleWeekoffDay(index, day.value)
                                      }
                                    />
                                    <span className="checkbox-label-compact">
                                      {day.label}
                                    </span>
                                  </label>
                                );
                              })}
                            </div>
                          </td>

                          {/* From Date */}
                          <td className="weekoff-date-col">
                            <div className="shift-assignment-date-wrapper">
                              {/* Visible DD-MM-YYYY field */}
                              <input
                                type="text"
                                className="shift-assignment-date-display"
                                value={
                                  assignment.from_date
                                    ? assignment.from_date
                                        .split("-")
                                        .reverse()
                                        .join("-")
                                    : ""
                                }
                                placeholder="dd-mm-yyyy"
                                readOnly
                                onClick={() => {
                                  weekoffAssignmentFromDateRefs.current[
                                    index
                                  ]?.showPicker();
                                }}
                              />

                              {/* Calendar icon */}
                              <FiCalendar
                                className="shift-assignment-calendar-icon"
                                onClick={() => {
                                  weekoffAssignmentFromDateRefs.current[
                                    index
                                  ]?.showPicker();
                                }}
                              />

                              {/* Hidden native date picker */}
                              <input
                                ref={(el) => {
                                  weekoffAssignmentFromDateRefs.current[index] =
                                    el;
                                }}
                                type="date"
                                className="shift-assignment-date-picker"
                                min="2000-01-01"
                                max="2099-12-31"
                                value={assignment.from_date || ""}
                                onChange={(e) => {
                                  const updated = [...userWeekoffAssignments];

                                  updated[index] = {
                                    ...updated[index],
                                    from_date: e.target.value,
                                  };

                                  setUserWeekoffAssignments(updated);
                                }}
                              />
                            </div>
                          </td>

                          {/* To Date */}
                          <td className="weekoff-date-col">
                            <div className="shift-assignment-date-wrapper">
                              {/* Visible DD-MM-YYYY field */}
                              <input
                                type="text"
                                className="shift-assignment-date-display"
                                value={
                                  assignment.to_date
                                    ? assignment.to_date
                                        .split("-")
                                        .reverse()
                                        .join("-")
                                    : ""
                                }
                                placeholder="dd-mm-yyyy"
                                readOnly
                                onClick={() => {
                                  weekoffAssignmentToDateRefs.current[
                                    index
                                  ]?.showPicker();
                                }}
                              />

                              {/* Calendar icon */}
                              <FiCalendar
                                className="shift-assignment-calendar-icon"
                                onClick={() => {
                                  weekoffAssignmentToDateRefs.current[
                                    index
                                  ]?.showPicker();
                                }}
                              />

                              {/* Hidden native date picker */}
                              <input
                                ref={(el) => {
                                  weekoffAssignmentToDateRefs.current[index] =
                                    el;
                                }}
                                type="date"
                                className="shift-assignment-date-picker"
                                min="2000-01-01"
                                max="2099-12-31"
                                value={assignment.to_date || ""}
                                onChange={(e) => {
                                  const updated = [...userWeekoffAssignments];

                                  updated[index] = {
                                    ...updated[index],
                                    to_date: e.target.value,
                                  };

                                  setUserWeekoffAssignments(updated);
                                }}
                              />
                            </div>
                          </td>

                          {/* Status */}
                          <td className="shift-status-col">
                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={Number(assignment.isactive) === 1}
                                onChange={(e) =>
                                  handleWeekoffStatusToggle(
                                    assignment,
                                    e.target.checked,
                                  )
                                }
                              />

                              <span className="slider"></span>
                            </label>
                          </td>

                          {/* Action */}
                          <td className="shift-action-col">
                            <button
                              type="button"
                              className="save-btn"
                              onClick={() => handleWeekoffRowSave(assignment)}
                            >
                              Save
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="no-shift-data">
                          No weekoff assignments found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {activeTab === "personal" && (
            <div className="form-actions">
              <button className="cancel-btn" onClick={handleCancel}>
                Cancel
              </button>

              <button className="save-btn" onClick={handleSave}>
                {editId ? "Update" : "Save"}
              </button>
            </div>
          )}

          {/* {(activeTab === "shift" || activeTab === "weekoff") && (
            <div className="form-actions">
              <button className="cancel-btn" onClick={handleCancel}>
                Cancel
              </button>
              <button className="save-btn" onClick={handleSaveAllAssignments}>
                Save
              </button>
            </div>
          )} */}
        </div>
      )}
    </div>
  );
}
